import SearchIcon from '@material-ui/icons/Search';
import { useStyles } from '../../../../styles';
import {
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from '@material-ui/core';

const PRIORITY_OPTIONS = [
  'All priority levels',
  'High Priority',
  'Medium Priority',
  'Low Priority',
];
interface SearchFilterBarProps {
  searchText: string;
  onSearchTextChange: (value: string) => void;
  priorityFilter: string;
  onPriorityFilterChange: (value: string) => void;
}

export function RecommendedActionsFilterBar({
  searchText,
  onSearchTextChange,
  priorityFilter,
  onPriorityFilterChange,
}: SearchFilterBarProps) {
  const classes = useStyles();

  return (
    <div className="flex flex-col sm:flex-row gap-2 sm:gap-3 mb-3">
      <div className="relative flex-1">
        <TextField
          className={`w-full pl-9 pr-3 py-2 rounded border text-xs sm:text-sm focus:outline-none focus:ring-2 ${classes.recommendedActionsSearchInput}`}
          variant="outlined"
          type="search"
          placeholder="Search recommended actions"
          onChange={e => onSearchTextChange(e.target.value)}
          value={searchText}
          InputProps={{ endAdornment: !searchText && <SearchIcon /> }}
        />
      </div>
      <div className="relative w-full sm:w-auto">
        <FormControl
          variant="outlined"
          className={classes.recommendedActionsSelect}
        >
          <InputLabel id="priority-filter-label" shrink>
            Priority
          </InputLabel>
          <Select
            labelId="priority-filter-label"
            label="Priority"
            variant="outlined"
            id="priority-filter"
            onChange={e => onPriorityFilterChange(e.target.value as string)}
            value={priorityFilter}
          >
            {PRIORITY_OPTIONS &&
              PRIORITY_OPTIONS.map((t: string) => (
                <MenuItem
                  key={`type-option-${t}`}
                  value={t}
                  className={classes.recommendedActionsMenuItem}
                >
                  {t}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </div>
    </div>
  );
}
